module.exports = __webpack_public_path__ + "img/btn_zoom_out.20102ede.svg";